module.exports = __webpack_public_path__ + "static/media/fashion-img7.b6a9c196.png";